import Input from "../General/Input";
import Button from "../General/Button";
import useWindowSize from "../../hooks/useWindowSize";
import Modal from "../General/Modal";
import { useFormik } from "formik";
import { setOrderPayload, responseStates } from "../../store/CoreSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import * as Yup from "yup";

function Requirements({ productName, data, show, onClose, onRequirementsSubmit } : any) {
    const initialValues : any = {
        quantity_required : null,
        required_credit_period : null,
        quantity_required_unit : 1
    }

    const requirementsSchema = Yup.object({
        'required_credit_period' : Yup.number().nullable().required('Credit Period is required!').typeError('Please enter a day in Number!').min(1, 'Credit Period must be between 1-90 days').max(90, 'Credit Period must be between 1-90 days'),
        'quantity_required' : Yup.number().nullable().required('Quantity is required!').typeError('Please enter a valid Quantity!').min(data ? data.minimum_order_quantity : 1, `Quantity must be at least ${data ? data.minimum_order_quantity : 1} KG`),
    })

    const size : any = useWindowSize();
    const dispatch : any = useDispatch();
    const { orderPayload } = useSelector((state : any) => state.core)
    const { values, errors, handleSubmit, handleBlur, handleChange, touched, resetForm } = useFormik({
        initialValues : initialValues,
        validationSchema : requirementsSchema,

        onSubmit : (values : any) => {
            const payload = {
                cart_items : [
                    {   
                        fixed_price : data.id,
                        quantity_required : values.quantity_required,
                        required_credit_period : values.required_credit_period,
                        quantity_required_unit : values.quantity_required_unit
                    }    
                ]
            }            
            dispatch(setOrderPayload(payload));
            onRequirementsSubmit(productName, data.price, values.quantity_required);
            onClose();
        }
    })

    useEffect(() => {
        if(orderPayload.responseStatus === responseStates.SUCCESS) 
            resetForm();
    }, [orderPayload.responseStatus])

    const getComponent = (data : any) => {
        if(size.width < 800)
            return <Modal show = {show} fullScreen> {data} </Modal>
        return <Modal transition="animateup" styles = "w-[50%]" show = {show}> {data} </Modal>
    }

    const handleClose = () => {
        resetForm();
        onClose();
    }
    return (
        getComponent(
            <div className="px-4 pt-2 pb-[25px]">
                <div className="flex justify-between items-center">
                    <h1 className="text-[#324D9F] text-[24px] my-0 lg:text-[30px]"> {productName} </h1>
                    <svg onClick = {handleClose} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 cursor-pointer">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </div>
                
                {
                    data &&
                    <div className="border border-[0.5px] border-[#B5B5B5]" style={{ borderRadius: '0px 0px 2px 2px' }}>
                        <div className="border-b border-b-[0.5px] border-b-[#B5B5B5] flex justify-between items-center p-[10px] lg:justify-start">
                            <p className="text-[15px] font-[400] lg:w-[50%]"> Manufacturer name </p>
                            <p className="text-[15px] font-[400]"> { data.manufacturer_name ? data.manufacturer_name : '-' } </p>
                        </div>
                        <div className="border-b border-b-[0.5px] border-b-[#B5B5B5] flex justify-between items-center p-[10px] lg:justify-start">
                            <p className="text-[15px] font-[400] lg:w-[50%]"> Pharmacopeia grades </p>
                            <p className="text-[15px] font-[400]"> 
                                {
                                    data.pharmacopoeia_grade_list.length > 0 ?
                                    data.pharmacopoeia_grade_list.map((grade : any, index : number) => (
                                        <span key={index}>
                                            { grade.name }{ index === data.pharmacopoeia_grade_list.length - 1 ? '' : ' / ' }
                                        </span>
                                    ))  
                                    :
                                    '-'
                                } 
                            </p>
                        </div>
                        <div className="border-b border-b-[0.5px] border-b-[#B5B5B5] flex justify-between items-center p-[10px] lg:justify-start">
                            <p className="text-[15px] font-[400] lg:w-[50%]"> Quality certificates </p>
                            <p className="text-[15px] font-[400]">  
                                {
                                    data.certificate_list.length > 0 ?
                                    data.certificate_list.map((certificate : any, index : number) => (
                                        <span key={index}>
                                            { certificate.name }{ index === data.certificate_list.length - 1 ? '' : ' / ' }
                                        </span>
                                    ))  
                                    :
                                    '-'
                                } 
                            </p>
                        </div>
                        <div className="border-b border-b-[0.5px] border-b-[#B5B5B5] flex justify-between items-center p-[10px] lg:justify-start">
                            <p className="text-[15px] font-[400] lg:w-[50%]"> Country of manufacturing </p>
                            <div className="text-[15px] font-[400]">  
                                {
                                    data.country ?
                                    <div className="flex items-center justify-center" >
                                        <img className="w-[20px] mr-2" src={data.country.flag_link} alt={data.country.short_name} loading="lazy"/>
                                        <p> { data.country.name } </p>
                                    </div>
                                    :
                                    '-'
                                }
                            </div>
                        </div>
                        <div className="border-b border-b-[0.5px] border-b-[#B5B5B5] flex justify-between items-center p-[10px] lg:justify-start">
                            <p className="text-[15px] font-[400] lg:w-[50%]"> Stock Available </p>
                            <p className="text-[15px] font-[400]"> { data.quantity_available } { data.quantity_available_unit_details.name } </p>
                        </div>
                        <div className="border-b border-b-[0.5px] border-b-[#B5B5B5] flex justify-between items-center p-[10px] lg:justify-start">
                            <p className="text-[15px] font-[400] lg:w-[50%]"> Shipping Terms</p>
                            <p className="text-[15px] font-[400]"> {data.shipping_term_details ? data.shipping_term_details.name : '-'} </p>
                        </div>
                        <div className="flex justify-between items-center p-[10px] lg:justify-start">
                            <p className="text-[15px] font-[400] lg:w-[50%]"> Price ($) </p>
                            <p className="text-[15px] font-[400]"> ${ data.price } {data.price_in_rupees ? `/₹${data.price_in_rupees}` : ''} </p>
                        </div>
                    </div>
                }

                <form onSubmit={handleSubmit} className="lg:flex lg:justify-between lg:items-end">
                    <div className="flex justify-between items-end mt-[48px] lg:mt-5 lg:w-[60%]">
                        <div className="w-[48%]">
                            <Input 
                                label = "Quantity Required"
                                labelColor = "#44444"
                                labelProperties = "text-[15px]"
                                outerProperties = "border border-[0.5px] border-[#324D9F] h-[40px] rounded"
                                properties = "h-[38px] rounded"
                                placeholder = "E.g. 100 Kg"
                                onChange = {handleChange}
                                value = {values.quantity_required}
                                name = 'quantity_required'
                                onBlur = {handleBlur}
                                error={errors.quantity_required}
                                touched={touched.quantity_required}
                            />
                        </div>

                        <div className="w-[48%]">
                            <Input 
                                label = "Required credit period (In Days)"
                                labelColor = "#44444"
                                labelProperties = "text-[15px]"
                                outerProperties = "border border-[0.5px] border-[#324D9F] h-[40px] rounded"
                                properties = "h-[38px] rounded"
                                placeholder = "E.g. 30 Days"
                                onChange = {handleChange}
                                value = {values.required_credit_period}
                                name = 'required_credit_period'
                                onBlur = {handleBlur}
                                error={errors.required_credit_period}
                                touched={touched.required_credit_period}
                            />
                        </div>

                    </div>

                    <div className="w-[44%] lg:w-[20%]">
                        <Button styles = "mt-6 bg-theme-orange text-white" width = '100%' height = {40}> Next </Button>
                    </div>
                </form>
            </div> 
        )
        
    )
}

export default Requirements